import { render, staticRenderFns } from "./PotentialSpaces.vue?vue&type=template&id=f6954ed4&"
import script from "./PotentialSpaces.vue?vue&type=script&lang=js&"
export * from "./PotentialSpaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports